
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
/**
 * Service AuthService
 */
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import * as Rx from 'rxjs';
import * as _ from 'lodash';
import { HttpParams } from "@angular/common/http";

import { HttpClientService } from './httpClient.service';

@Injectable()
export class PIDService {

  private _baseURL = "/api/pids/";

  constructor(private _http: HttpClientService) {
  }

  getPIDTypes() {
    let url = this._baseURL + "types";

    return this._http.get(url);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  getFromOwner(id) {
    //console.log("get from owner");
    let url = this._baseURL + "owner/" + id;

    return this._http.get(url);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  getRoomsFromOwner(id) {
    //console.log("get from owner");
    let url = this._baseURL + "owner/rooms/" + id;

    return this._http.get(url);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  getFromOwnerWithStats(id) {
    //console.log("get from owner with stats");
    let url = this._baseURL + "owner/stats/" + id;

    return this._http.get(url);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  get(id) {
    let url = this._baseURL + id;

    return this._http.get(url);
  }

  getAll(userFilter, pidFilter, search) {
    let url = this._baseURL;
    let params = new HttpParams();
    if (userFilter && userFilter != -1) {
      params = params.set('role', userFilter);
    }
    if (pidFilter && pidFilter != -1) {
      params = params.set('pidState', pidFilter);
    }
    if (search) {
      params = params.set('q', search);
    }
    if (params.keys().length) {
      url += '?' + params.toString();
    }
    console.log('getall', url, userFilter, pidFilter);
    return this._http.get(url);
  }

  addRooms(id, data) {
    let url = this._baseURL + "addRooms/" + id;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify(data), headers);
  }

  toDate(d){
    return new Date(d).toISOString();
  }

  expires(id, u) {
    let url = this._baseURL + 'expires/' + id;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let payload = {
      expired: u.expired,
   
      createdAt: this.toDate(u.createdAt)
    }

    if (u.expires)  payload['expires'] = this.toDate(u.expires)
    if (u.createAt) payload['createdAt'] = this.toDate(u.createdAt)

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify(payload), headers);/*
      .subscribe(res => res, 
      err => this._handleError(err));*/
  }

  changeOwner(id, data) {
    let url = this._baseURL + "changeOwner/" + id;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify(data), headers);
  }

  switchOwner(id, data) {
    let url = this._baseURL + "switchOwner/" + id;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify(data), headers);
  }

  delete(id) {
    let url = this._baseURL + id;

    //noinspection TypeScriptValidateTypes
    return this._http.delete(url);/*.subscribe(
      res => res, err => this._handleError(err));*/
    }

  addPID(newPID, id) {
    let url = this._baseURL + "owner/" + id;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.post(url, JSON.stringify(newPID), headers);
  }

  uploadImg(url, file) {
    return Rx.Observable.create(obs => {
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.onload = function () {
        if (xhr.status === 200) {
          obs.next("Success");
        } else {
          obs.error("Could not upload file.");
        }
      };
      xhr.onerror = function () {
        obs.error("Could not upload file.");
      };
      xhr.send(file);
    });
  }

  getAdminTemplates() {
    let url = this._baseURL + "templates";

    return this._http.get(url);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  saveAdminTemplates(templates) {
    let url = this._baseURL + "templates";
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify(templates), headers)/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  updatePID(newPID, id) {
    let url = this._baseURL + "owner/" + id;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify(newPID), headers);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }


  printAll(id) {
    let url = this._baseURL + "printAll/" + id;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify({}), headers);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  completePrint(id, token) {
    let url = this._baseURL + "completePrint/" + id + '/' + token;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify({}), headers);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }


  printTransferPDF(id, pid) {
    let url = this._baseURL + "transferPDF/" + id + '/' + pid;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify({}), headers);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  completeTransferPDF(id, pid, token) {
    let url = this._baseURL + "completeTransferPDF/" + id + '/' + pid + '/' + token;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify({}), headers);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  initTransfer(pid, email, transferType, transferSubType) {
    let url = this._baseURL + "initTransfer/" + pid;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this._http.put(url, JSON.stringify({ email: email, transferType: transferType, transferSubType: transferSubType }), headers)/*.subscribe(
      res => res, err => this._handleError(err))*/;
  }

  getTransferredPID(pid, token) {
    let url = this._baseURL + "transferred/" + pid + "/" + token;

    return this._http.get(url);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  completeTransfer(pid, token) {
    let url = this._baseURL + "completeTransfer/" + pid;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify({ token: token }), headers)/*.subscribe(
      res => res, err => this._handleError(err))*/;
  }

  changeSorting(ordering) {
    var url = this._baseURL + "ordering/";
    var headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this._http.put(url,
      JSON.stringify({ sortOrder: ordering}), headers).pipe(
      catchError(this._handleError));

  }

  private _handleError(error) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return observableThrowError(error['message'] || error['_body'] || 'Server error');
  }
}
